import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured. Running in demo mode.')
}

// flowType: 'implicit' — auth callbacks land with tokens in the URL hash
// (#access_token=...&type=invite&...). We rely on `type=invite` / `type=recovery`
// in the hash to trigger the set-password UI in Login.jsx via an inline script
// in index.html. The newer PKCE default (2.40+) uses ?code=... query params
// and consumes the `type` server-side, so the client can't distinguish an
// invite from a normal sign-in — which let invitees skip the set-password
// step entirely. Implicit is fine for a browser SPA; PKCE matters more for
// native/mobile apps where redirect URLs can be intercepted.
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: { flowType: 'implicit' },
    })
  : null

export const isDemoMode = !supabase

export async function uploadFile(file, bucket, prefix = '') {
  if (isDemoMode) {
    return { path: `demo/${file.name}`, url: URL.createObjectURL(file) }
  }
  const ext = file.name.split('.').pop()
  const name = `${prefix}${Date.now()}-${Math.random().toString(36).slice(2, 11)}.${ext}`
  const { data, error } = await supabase.storage
    .from(bucket)
    .upload(name, file, { cacheControl: '3600', upsert: false })
  if (error) throw error
  const { data: urlData } = supabase.storage.from(bucket).getPublicUrl(data.path)
  return { path: data.path, url: urlData.publicUrl }
}
